<p class="download-inst">{{'What do you want to download ?' | translate | async}}</p>
@if (!(archiveConfig != undefined && archiveConfig.list != undefined)) {
  <div class="col-sm-12">
    @if (roleService.checkAccessPermission('downloadCSV','requested_downloads','report-management')) {
      <button type="button"  class="primary-btn float-right mb-1" (click)="downloadBtn('downloadCSV',$event)">{{'Download All'| translate | async}}</button>
    }
    @if (roleService.checkAccessPermission('downloadAll','requested_downloads','report-management')) {
      <button type="button"  class="primary-btn float-right mb-1" (click)="downloadBtn('downloadAll',$event)">{{'Download All(EXCEL)'| translate | async}}</button>
    }
    <button type="button" class="primary-btn float-right mb-1" (click)="downloadBtn('download',$event, {downloadType : 'xlDownload'})">{{'Download Current as XLS' | translate | async}} </button>
    <button type="button" class="primary-btn float-right mb-1" (click)="downloadBtn('download',$event)">{{'Download Current as Csv' | translate | async}}</button>
  </div>
}
@if (archiveConfig != undefined && archiveConfig.list != undefined) {
  <div class="col-sm-12" >
    @if (roleService.checkAccessPermission('downloadCSV','requested_downloads','report-management')) {
      <button type="button"  class="primary-btn float-right mb-1" (click)="downloadBtn('downloadCSV',$event)">{{'Download' | translate | async}} {{numberDay}} {{'Data' | translate | async}}</button>
    }
    @if (roleService.checkAccessPermission('downloadAll','requested_downloads','report-management')) {
      <button type="button"  class="primary-btn float-right mb-1" (click)="downloadBtn('downloadAll',$event)">{{'Download' | translate | async}} {{numberDay}} {{'Data(EXCEL)' | translate | async}}</button>
    }
    <button type="button" class="primary-btn float-right mb-1" (click)="downloadBtn('download',$event)">{{'Download Current' | translate | async}}</button>
    <button type="button" class="primary-btn float-right mb-1" (click)="downloadBtn('download',$event, {downloadType : 'xlDownload'})">{{'Download Current as XLS' | translate | async}} </button>

    @if (downloadOnly.length>0 && roleService.checkAccessPermission('downloadCSV','requested_downloads','report-management')) {
      <button type="button"  class="primary-btn float-right mb-1" (click)="setArchivePolicy(downloadOnly[0])">{{'Download Archived Data'| translate | async}}</button>
    }
  </div>
}

<!--chunk download instructions-->
@if (!dialogConfig.isEditableGrid) {
  <div class="chk-download">
    <div class="sm-heading">Note : </div>
    <div class="chk-ins">
      Please press Ctrl before selecting any download option to enable chunk download.
    </div>
    <div class="chk-ins">
      Downloaded file will be visible in My Downloads.
    </div>
    <div class="chk-ins">
      Text formatting such as bold, colour and table is only available in the XLS download.
    </div>
    @if (archiveConfig != undefined && archiveConfig.list != undefined) {
      <div class="chk-ins">
        Ctrl + Click  will not work for Download Archive Data button.
      </div>
    }
  </div>
}
<!--chunk download instructions-->
